import {networker} from "../http";
import {cachedGet} from "@/service/api/cacheHttp";

const serverService = {
    getServers(){
        return networker.get("server/")
    },
    getFilters(){
        return cachedGet("server/filter")
    }
}

export default serverService